import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "lz-mt-6 lz-flex lz-flex-col lz-items-center"
}
const _hoisted_2 = ["aria-expanded"]

import CollapseTransition from '@ivanv/vue-collapse-transition/src/CollapseTransition.vue'
import { breakpoint } from '@/mobile'
import { computed, nextTick, onBeforeUnmount, onMounted, ref } from 'vue'
import LzIcon from '@/components/base/LzIcon.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LzShowMore',
  props: {
    initialVisibleCount: { default: 3 },
    mobileInitialVisibleCount: { default: undefined },
    desktopInitialVisibleCount: { default: undefined },
    enableMobile: { type: Boolean, default: true },
    enableDesktop: { type: Boolean, default: true },
    expandLabel: {},
    collapseLabel: {},
    allowCollapse: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props;



const sourceContainer = ref<HTMLElement | null>(null)
const visibleContainer = ref<HTMLElement | null>(null)
const overflowContainer = ref<HTMLElement | null>(null)
const expanded = ref(false)
const isMobile = ref(false)
const items = ref<HTMLElement[]>([])

const currentEnabled = computed(() => isMobile.value ? props.enableMobile : props.enableDesktop)
const currentInitialVisibleCount = computed(() => {
    if (isMobile.value) {
        return props.mobileInitialVisibleCount ?? props.initialVisibleCount
    }

    return props.desktopInitialVisibleCount ?? props.initialVisibleCount
})
const canTruncate = computed(() => currentEnabled.value && items.value.length > currentInitialVisibleCount.value)
const showOverflow = computed(() => canTruncate.value && expanded.value)
const showExpandButton = computed(() => canTruncate.value && !expanded.value)
const showCollapseButton = computed(() => canTruncate.value && expanded.value && props.allowCollapse)

function collectItems(): void {
    if (!sourceContainer.value) {
        items.value = []
        return
    }

    items.value = Array.from(sourceContainer.value.children).filter((child): child is HTMLElement => child instanceof HTMLElement)
}

function clearContainer(container: HTMLElement | null): void {
    if (!container) {
        return
    }

    while (container.firstChild) {
        container.removeChild(container.firstChild)
    }
}

function appendItems(container: HTMLElement | null, nodes: HTMLElement[]): void {
    if (!container) {
        return
    }

    nodes.forEach(node => {
        container.appendChild(node)
    })
}

function renderItems(): void {
    isMobile.value = window.innerWidth < breakpoint

    clearContainer(visibleContainer.value)
    clearContainer(overflowContainer.value)

    if (!currentEnabled.value) {
        appendItems(visibleContainer.value, items.value)
        return
    }

    appendItems(visibleContainer.value, items.value.slice(0, currentInitialVisibleCount.value))
    appendItems(overflowContainer.value, items.value.slice(currentInitialVisibleCount.value))
}

function onResize(): void {
    renderItems()
}

function toggle(): void {
    if (expanded.value && !props.allowCollapse) {
        return
    }

    expanded.value = !expanded.value
}

onMounted(async () => {
    await nextTick()
    collectItems()
    renderItems()
    window.addEventListener('resize', onResize)
})

onBeforeUnmount(() => {
    window.removeEventListener('resize', onResize)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      ref_key: "sourceContainer",
      ref: sourceContainer,
      class: "lz-hidden"
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 512),
    _createElementVNode("div", {
      ref_key: "visibleContainer",
      ref: visibleContainer
    }, null, 512),
    _createVNode(CollapseTransition, null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          ref_key: "overflowContainer",
          ref: overflowContainer
        }, null, 512), [
          [_vShow, showOverflow.value]
        ])
      ]),
      _: 1
    }),
    (showExpandButton.value || showCollapseButton.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", {
            class: "lz-inline-flex lz-flex-col lz-items-center lz-font-bold lz-text-primary lz-bg-transparent lz-border-0 lz-p-0 lz-cursor-pointer lz-group",
            type: "button",
            "aria-expanded": expanded.value ? 'true' : 'false',
            onClick: toggle
          }, [
            _createTextVNode(_toDisplayString(expanded.value ? _ctx.collapseLabel : _ctx.expandLabel) + " ", 1),
            _createVNode(LzIcon, {
              name: "mini-arrow2",
              class: "lz-stroke-primary lz-w-6 lz-h-6 lz-shrink-0 group-hover:lz-translate-y-2 lz-transition-transform lz-duration-300"
            })
          ], 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})